











import { auth as authStore, doctor as doctorStore, patient as patientStore } from "@/store/modules";
import { Component, Vue } from "vue-property-decorator";
import { passwordRules } from "@/utils/validation";
import { IAuthService } from '@/interfaces/Services';
import { inject } from 'inversify-props';
import Axios from 'axios';
import LambdaDownloader from '@/utils/lambda_downloader';
import DependencyIdentifiers from '@/ioc/DependencyIdentifiers';

@Component({})
export default class RecoveryDownloadCard extends Vue {
  isLoading = false;
  @inject(DependencyIdentifiers.AuthService)
  private authService!: IAuthService;

  async download() {
    if (this.isLoading) {
      return;
    }

    const recoveryData = await this.authService.recovery();
    let email: string;
    if (authStore.isPatient) {
      email = patientStore.items[`${authStore.authPatientId}`].email;
    } else {
      email = doctorStore.items[`${authStore.authDoctorId}`].contactEmail;
    }

    const download = new LambdaDownloader(
      {key: recoveryData.key, email},
      `recovery-key-to-pdf`,
      `hemonaplo-recovery-${email}`,
      (isLoading) => this.isLoading = isLoading,
    );
    await download.start();
  }
}
